import Vue from 'vue'
import Vuex from 'vuex'
import catalogs from './modules/catalogs.js'
import fishingPermit from './modules/fishing-permit.js'
import dashboard from './modules/dashboard.js'

import { apiSecond, setTokenRefresher } from '@/boot/axios'
import i18n from '@/i18n'
import { resetUnseen } from '@/components/system-updates/unseenStore'

Vue.use(Vuex)

function tokenTime() {
	const initedTime = localStorage.getItem('token_time')
	const currentTime = new Date().getTime()
	const substract = (currentTime - initedTime) / 1000
	const tokenLifeTime = 10 * 60

	return tokenLifeTime - substract
}

function tokenExpired() {
	const time = tokenTime()

	return time <= 0
}

let timerId
// Общий промис обновления токена: параллельные вызовы (таймер, loadFromLocal,
// несколько 401 подряд) используют один запрос refreshToken, а не несколько.
let refreshPromise = null

function redirectToLogin() {
	const loginPath = '/' + i18n.locale + '/login'
	if (!window.location.pathname.startsWith(loginPath)) {
		window.location = loginPath
	}
}

const store = new Vuex.Store({
	state: {
		access_token: '',
		refresh_token: '',
		notification: null,
		userObject: null,
		userRoles: [],
		sign: [],
	},
	getters: {
		userPermission: (state) => (roleList) => {
			if (!roleList || !roleList.length) return false
			let roleAccesses = state.userRoles.filter((element) => {
				return roleList.find((el) => {
					if (el == element) return true
				})
			})
			return roleAccesses.length ? true : false
		},
		getSign: (state) => {
			return state.sign
		},
		_getUserObject(state) {
			return state.userObject
		},
	},
	mutations: {
		setSign(state, payload) {
			state.sign.push(payload)
		},
		getUserRoles(state, roles) {
			state.userRoles = roles
		},
		SET_USER_OBJECT(state, user) {
			state.userObject = user
		},
		getUserNotifications(state, notification) {
			state.notification = notification
		},
		SET_ACCESS_TOKEN(state, payload) {
			state.access_token = payload
		},
		SET_REFRESH_TOKEN(state, payload) {
			state.refresh_token = payload
		},
	},
	actions: {
		logout({ commit }) {
			localStorage.removeItem('token')
			localStorage.removeItem('access_token')
			localStorage.removeItem('refresh_token')
			localStorage.removeItem('token_time')

			commit('SET_ACCESS_TOKEN', null)
			commit('SET_REFRESH_TOKEN', null)
			commit('setSign', [])
			commit('SET_USER_OBJECT', null)
			commit('getUserRoles', [])
			resetUnseen()
		},
		set_tokens({ commit, dispatch }, payload) {
			if (timerId) clearTimeout(timerId)
			localStorage.setItem('token', 'Bearer ' + payload.access_token)
			localStorage.setItem('access_token', payload.access_token)
			localStorage.setItem('refresh_token', payload.refresh_token)
			if (payload.token_time) localStorage.setItem('token_time', payload.token_time)

			// Set default language if not already set
			if (!localStorage.getItem('selected_lang_locale')) {
				localStorage.setItem('selected_lang_locale', i18n.locale)
			}

			commit('SET_ACCESS_TOKEN', payload.access_token)
			commit('SET_REFRESH_TOKEN', payload.refresh_token)

			dispatch('setTimer')
		},
		setTimer({ dispatch, state }) {
			if (!state.access_token || !state.refresh_token) return

			timerId = setTimeout(() => {
				dispatch('fetchNewToken')
			}, tokenTime() * 1000)
		},
		/**
		 * Обновляет пару токенов. Возвращает true при успехе.
		 * При любой неудаче (сетевая ошибка, 401, 200 с token.error, пустой ответ)
		 * разлогинивает и уводит на страницу входа.
		 */
		fetchNewToken({ state, dispatch }) {
			if (refreshPromise) return refreshPromise

			refreshPromise = (async () => {
				const refresh_token = state.refresh_token || localStorage.getItem('refresh_token')
				if (!refresh_token) {
					await dispatch('logout')
					redirectToLogin()
					return false
				}
				try {
					const response = await apiSecond.post('v1/user/refreshToken', {
						refresh_token,
					})
					const token = response?.data?.token
					if (token && !token.error && token.access_token && token.refresh_token) {
						dispatch('set_tokens', {
							access_token: token.access_token,
							refresh_token: token.refresh_token,
							token_time: new Date().getTime(),
						})
						return true
					}
				} catch (error) {
					// падаем в общий logout ниже
				}
				await dispatch('logout')
				redirectToLogin()
				return false
			})().finally(() => {
				refreshPromise = null
			})

			return refreshPromise
		},
		async loadFromLocal({ dispatch, commit }) {
			const access_token = localStorage.getItem('access_token')
			const refresh_token = localStorage.getItem('refresh_token')
			const token_time = localStorage.getItem('token_time')
			if (!access_token) {
				redirectToLogin()
				return
			}

			// Set default language if not already set
			if (!localStorage.getItem('selected_lang_locale')) {
				localStorage.setItem('selected_lang_locale', i18n.locale)
			}

			if (tokenExpired()) {
				if (
					refresh_token &&
					Math.floor((new Date().getTime() - +token_time) / 1000) <
						+process.env.VUE_APP_REFRESH_TOKEN_TIME
				) {
					commit('SET_REFRESH_TOKEN', refresh_token)
					await dispatch('fetchNewToken')
				} else {
					await dispatch('logout')
					redirectToLogin()
				}
			} else {
				await dispatch('set_tokens', {
					access_token,
					refresh_token,
				})
			}
		},
	},
	modules: {
		catalogs,
		fishingPermit,
		dashboard,
	},
})

// Интерцептор axios при 401 вызывает обновление токена через store
setTokenRefresher(() => store.dispatch('fetchNewToken'))

export default store
